var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 69 47",
    style: {
      enableBackground: "new 0 0 69 47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000072256390275787083870000003213040160052668295_);}\n\t.st11{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 69,
    height: 47
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029765451730247048070000011721825005069706159_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000029765451730247048070000011721825005069706159_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M64,9.8h-2.9v4.3H64V9.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M64,17.5h-2.9v4.3H64V17.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M60.7,14.4h-4.6v2.7h4.6V14.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M69,14.4h-4.6v2.7H69V14.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M55.7,9.8h-2.9v4.3h2.9V9.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M55.7,17.5h-2.9v4.3h2.9V17.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M52.4,14.4h-4.6v2.7h4.6V14.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M55.7,2.1h-2.9v4.3h2.9V2.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M52.4,6.8h-4.6v2.7h4.6V6.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M60.7,6.8h-4.6v2.7h4.6V6.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.2,44.2l1.2-3.5c1.2,0.5,2.8,1,4.8,1c2.7,0,5.3-1.1,5.3-4.3v-0.5c-1.2,0.6-2.6,1-4.7,1 c-5.5,0-8.6-3.3-8.6-8.1c0-4.6,3.6-8.5,9.5-8.5c2.8,0,5.6,0.7,8,2.2v12.6c0,2.1-0.3,3.3-0.8,4.4c-1.3,3-4.5,4.7-9.1,4.7 C36.2,45.3,33.9,44.9,32.2,44.2L32.2,44.2z M43.6,25.7c-0.8-0.6-2.3-1-3.6-1c-3.4,0-5.3,2.3-5.3,5.1c0,2.7,1.6,4.8,4.9,4.8 c1.8,0,3.2-0.4,4-1.1L43.6,25.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M0,21.8h4.1l0.1,1.7c1.4-1.3,3.4-2,5.3-2c3.9,0,6.5,2.1,6.5,6.2v9.8h-4.3v-9.4c0-2.3-1.3-3.3-3.2-3.3 S4.8,26,4.2,27.4v10h-4.3L0,21.8L0,21.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M19.4,21.8h4l0.1,2c1.3-1.5,3-2.3,5.2-2.3c0.8,0,1.7,0.2,2.4,0.5l-1.3,3.6c-0.6-0.2-1.6-0.3-2.3-0.3 c-1.8,0-3.3,1.1-3.9,2.5v9.8h-4.3L19.4,21.8L19.4,21.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M52.4,37.6c-0.3,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.5s-0.4-0.5-0.5-0.7c-0.3-0.6-0.3-1.2,0-1.8 c0.1-0.3,0.3-0.5,0.5-0.7s0.5-0.4,0.8-0.5s0.6-0.2,1-0.2c0.3,0,0.7,0.1,1,0.2c0.6,0.2,1.1,0.7,1.3,1.3s0.2,1.2,0,1.7 c-0.1,0.3-0.3,0.5-0.5,0.7s-0.5,0.4-0.8,0.5C53,37.5,52.7,37.6,52.4,37.6L52.4,37.6z M52.4,37.1c0.3,0,0.5,0,0.8-0.1 c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.3-0.4,0.4-0.6c0.2-0.5,0.2-1,0-1.4c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.2-0.5-0.4-0.8-0.5 s-0.6-0.1-0.9,0c-0.3,0.1-0.6,0.2-0.9,0.4c-0.2,0.2-0.4,0.4-0.6,0.7c-0.2,0.5-0.2,1,0,1.4c0.1,0.2,0.2,0.4,0.4,0.6 c0.2,0.2,0.4,0.3,0.6,0.4C51.9,37.1,52.1,37.1,52.4,37.1L52.4,37.1z M51.5,34.1h1c0.1,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2 c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0,0.2,0.1,0.2c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.4,0.3l0.6,1h-0.5l-0.6-0.9h-0.4v0.9h-0.5 L51.5,34.1z M52.5,35.2c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.1-0.1c0.1-0.1,0.1-0.2,0.1-0.3v-0.1c0,0,0-0.1-0.1-0.1 c-0.1-0.1-0.2-0.1-0.3-0.1h-0.4v0.7L52.5,35.2z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7e31b94d64583a78bc1a0460158d6bf9.svg";
export { ForwardRef as ReactComponent };